import React from 'react';
import {AisinoCol, AisinoRow} from "../../baseComponent/rowAndCol";
import {colLayout} from "../../constant/css";

function formItemLayout(formItems){
    let formItemsLayout = [];
    if (formItems){
        for(let j = 0,len=formItems.length; j < len; j= j+2) {
            if (len == j+1){
                formItemsLayout.push(
                    <AisinoRow key={j/2} gutter={24}>
                        <AisinoCol {...colLayout}>
                            {formItems[j]}
                        </AisinoCol>
                    </AisinoRow>
                )
            } else {
                formItemsLayout.push(
                    <AisinoRow key={j/2} gutter={24}>
                        <AisinoCol {...colLayout}>
                            {formItems[j]}
                        </AisinoCol>
                        <AisinoCol {...colLayout}>
                            {formItems[j+1]}
                        </AisinoCol>
                    </AisinoRow>
                )
            }

        }
        return formItemsLayout;
    }
}

export default formItemLayout;